__turbopack_context__.v({
  "backgroundImage": "rYbzVq_backgroundImage",
  "contentWrapper": "rYbzVq_contentWrapper",
  "downloadButton": "rYbzVq_downloadButton",
  "sectionContainer": "rYbzVq_sectionContainer",
  "subtitle": "rYbzVq_subtitle",
  "title": "rYbzVq_title",
});
